import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { SideSheetHeaderProps } from "./types";

export function SideSheetHeader({
  title,
  description,
  icon,
  tags,
  actions,
  children,
}: SideSheetHeaderProps) {
  if (children) {
    return (
      <div className="bg-page/50 rounded-xl">
        <div className="px-6 py-5">{children}</div>
        <div className="h-px bg-gradient-to-r from-border via-border to-transparent" />
      </div>
    );
  }

  return (
    <div className="bg-page/50 rounded-xl">
      <div className="flex items-start justify-between px-6 py-5">
        <div className="flex items-start gap-3 min-w-0 flex-1">
          {icon && (
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-soft text-accent">
              {icon}
            </div>
          )}
          <div className="min-w-0 flex-1">
            <Dialog.Title className="text-[17px] font-semibold text-primary leading-snug truncate pr-2">
              {title}
            </Dialog.Title>
            {(description || tags) && (
              <Dialog.Description className="flex items-center gap-2 mt-1.5 flex-wrap">
                {tags?.map((tag) => {
                  const tagKey = `${tag.label}-${tag.variant ?? "default"}`;
                  if (tag.variant === "status") {
                    return (
                      <span
                        key={tagKey}
                        className="inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium"
                        style={{
                          backgroundColor: tag.bgColor,
                          color: tag.color,
                          borderColor: tag.color ? `${tag.color}33` : undefined,
                        }}
                      >
                        {tag.label}
                      </span>
                    );
                  }
                  return (
                    <span
                      key={tagKey}
                      className="inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium"
                      style={{
                        backgroundColor: tag.bgColor,
                        color: tag.color,
                      }}
                    >
                      {tag.label}
                    </span>
                  );
                })}
                {description && tags && tags.length > 0 && (
                  <span className="text-[11px] text-muted font-medium">
                    {description}
                  </span>
                )}
                {description && (!tags || tags.length === 0) && (
                  <span className="text-[13px] font-normal text-secondary">
                    {description}
                  </span>
                )}
              </Dialog.Description>
            )}
          </div>
        </div>
        <div className="flex items-center gap-0.5 shrink-0 ml-2">
          {actions}
          <Dialog.Close
            className="h-8 w-8 rounded-lg flex items-center justify-center text-muted hover:text-primary hover:bg-card-hover transition-colors cursor-pointer"
            aria-label="Close"
          >
            <X size={16} />
          </Dialog.Close>
        </div>
      </div>
      <div className="h-px bg-gradient-to-r from-border via-border to-transparent " />
    </div>
  );
}
